<template>
	<RadioGroup v-model="floorplanType">
		<RadioGroupLabel class="sr-only">Floorplan Type</RadioGroupLabel>
		<div class="grid grid-cols-2 gap-6">
			<RadioGroupOption
				as="template"
				v-for="type in types"
				:key="type.name"
				:value="type.name"
				v-slot="{ active, checked }"
			>
				<div
				class="col-span-1 relative flex flex-col cursor-pointer focus:outline-none group"
				>
					<div
						:class="[
							active
							? ''
							: '',
							checked ? 'scale-105 shadow-lg ring-2 ring-secondary' : '',
						]"
						class="flex items-center justify-between w-full rounded-lg shadow-md overflow-hidden py-4 h-[280px] group-hover:shadow-lg transition ease-in-out"
					>
						<img :src="type.image" :alt="type.name" />
					</div>
					<RadioGroupLabel
					as="p"
					:class="checked ? 'text-black' : 'text-gray-400'"
					class="font-medium text-center mt-3 transition"
					>
                        <span v-if="type.name === '3D'">3D (37€)</span>
                        <span v-if="type.name === '2D'">2D (24 - 27€)</span>
					</RadioGroupLabel>
				</div>
			</RadioGroupOption>
		</div>
	</RadioGroup>
</template>

<script>
import {
	RadioGroup,
	RadioGroupDescription,
	RadioGroupLabel,
	RadioGroupOption
} from '@headlessui/vue'

import {
	useForm,
	useField,
	useIsFormValid,
	useIsFormDirty,
	useFormValues,
	useValidateForm,
} from 'vee-validate'
import * as yup from 'yup'

import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'

const types = [
  {
    name: '2D',
	image: '/static/grundrisse/assets/images/2d-preview.png',
  },
  {
    name: '3D',
	image: '/static/grundrisse/assets/images/3d-preview.png',
  },
]

export default {
	components: {
		RadioGroup,
		RadioGroupDescription,
		RadioGroupLabel,
		RadioGroupOption
	},
	emits: ['changed'],
	setup(_, { emit }) {
		const store = useStore()

		const schema = computed(() => {
			return yup.object({
				floorplanType: yup.string().required()
			})
		})



		const { errors, setValues } = useForm({
			validationSchema: schema,
		})

		const isValid = useIsFormValid()
		const isDirty = useIsFormDirty()
		const formValues = useFormValues()
		const validate = useValidateForm()

		const { value: floorplanType } = useField('floorplanType')

		const formDataValues = computed(() => {
			return { ...store.state.steps.formData }
		})

		const formData = computed(() => {
			return {
				formValues: { ...formValues.value },
				isValid: isValid.value,
				isDirty: isDirty.value,
				validate: validate,
			}
		})

		onMounted(() => {
			setValues(formDataValues.value)

			if (!floorplanType.value) {
				floorplanType.value = ref(types[0].name)
			}
		})

		watch(
			() => formData,
			(data) => {
				emit('changed', data)
			},
			{ deep: true }
		)

		return {
			formData,
			floorplanType,
			types,
			errors
		}
	},
}
</script>
